import { Pipe, PipeTransform } from '@angular/core';
import { Const } from '@app/shared';
import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('es');

@Pipe({
  name: 'iwDateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const [manualFormat] = args;
    const format = manualFormat ? manualFormat : Const.DATE_FMT;
    return value ? moment(value).format(format) : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/moment/date-format.pipe.ts